import React from 'react';
import CustomLink from 'components/CustomLink/CustomLink';
import { urls } from 'shared/constants/routing.constants';

export const HomeLink: React.FC = () => (
  <CustomLink href={urls.commonPages.home} target="_blank" rel="noopener noreferrer">
    Deb8.TV
  </CustomLink>
);
